import { InsuranceHistorySummaryDTO } from '@components/InsuranceHistory/models/InsuranceHistorySummaryDTO.model';
import { createSlice } from '@reduxjs/toolkit';

interface InsuranceHistorySummaryState {
  data: InsuranceHistorySummaryDTO;
  loading: boolean;
  error: string | null;
}

const initialState: InsuranceHistorySummaryState = {
  data: {
    freelancer: {
      totalFreelancingYears: 0,
      totalFreelancingMonths: 0,
      totalFreelancingDays: 0,
      items: []
    },
    employee: {
      totalDays: 0,
      providers: []
    }
  },
  loading: true,
  error: null
};

const insuranceHistorySummarySlice = createSlice({
  name: 'insuranceHistorySummary',
  initialState,
  reducers: {
    setInsuranceHistorySummary: (state, action) => {
      state.data = action.payload.data;
      state.loading = action.payload.loading;
      state.error = action.payload.error;
    }
  }
});

export const InsuranceHistorySummaryActions = insuranceHistorySummarySlice.actions;

export const InsuranceHistorySummaryReducer = insuranceHistorySummarySlice.reducer;
